import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import SuppresantTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import fireSuppresantIcon from "../../../../../assets/design-revamp-company/category-icons/suppressant_icon.svg";
const SuppresantContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="emission-gas-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("SUPPRESSANT_INPUTS")}
          isNormal={true}
          number={"3.3"}
          icon={fireSuppresantIcon}
        />
      </div>

      {showTable && <SuppresantTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default SuppresantContents;
